import { TggPalette } from './palette.type';
import { lightPrimitives } from './primitives';
import { TggPrimitives } from './primitives.type';

export const createTggPalette = (primitives: TggPrimitives): TggPalette => {
    return {
        border: {
            disabled: primitives.neutral[800],
            field: primitives.neutral[800],
            attention: primitives.electricGreen[800],
            warning: primitives.ragAmber[500],
            action: {
                main: primitives.energyBlue[500],
                inverse: primitives.electricGreen[500],
                error: primitives.ragRed[500],
                secondaryInverse: primitives.electricGreen[500],
            },
            inverse: {
                main: primitives.neutral[0],
                disabled: primitives.neutral[200],
            },
            focus: {
                main: primitives.energyBlue[500],
                inverse: primitives.electricGreen[500],
            },
            rule: {
                main: primitives.neutral[200],
                on: {
                    container: primitives.darkBlue[400],
                },
            },
            selection: {
                deactivated: primitives.energyBlue[700],
                activated: primitives.energyBlue[700],
                disabled: primitives.darkBlue[100],
            },
            product: {
                ultimate: primitives.product.ultimateOrangeRed,
                standard: primitives.legacy.brand.legacyCyan,
                offpeak: primitives.product.offPeakSilverGrey,
                student: primitives.legacy.brand.darkBlue,
            },
        },
        graphic: {
            on: {
                inverse: {
                    strong2: primitives.pink[500],
                    strong4: primitives.purple[500],
                    subtle2: primitives.energyBlue[500],
                },
                attention: primitives.electricGreen[600],
                brand: {
                    strong1: primitives.electricGreen[500],
                    subtle1: primitives.cyan[500],
                    subtle2: primitives.purple[400],
                    subtle3: primitives.energyBlue[600],
                },
            },
        },
        icon: {
            information: primitives.legacy.brand.legacyCyan[600],
            error: primitives.ragRed[500],
            warning: primitives.legacy.rag.amber[500],
            success: primitives.ragGreen[600],
            action: {
                main: primitives.energyBlue[500],
                hover: primitives.energyBlue[600],
                pressed: primitives.energyBlue[700],
                disabled: primitives.neutral[800],
                inverse: {
                    main: primitives.electricGreen[500],
                    hover: primitives.electricGreen[600],
                    pressed: primitives.electricGreen[700],
                    disabled: primitives.neutral[200],
                },
            },
            content: {
                main: primitives.darkBlue[500],
                inverse: primitives.neutral[0],
            },
            on: {
                attention: primitives.electricGreen[800],
                success: primitives.legacy.rag.green[700],
                error: primitives.ragRed[500],
                information: primitives.cyan[500],
                action: {
                    main: primitives.neutral[0],
                    inverse: primitives.electricGreen[800],
                    secondary: primitives.energyBlue[500],
                    secondaryInverse: primitives.electricGreen[500],
                    secondaryTonal: primitives.energyBlue[600],
                },
                promoSuccess: {
                    main: primitives.electricGreen[800],
                    inverse: primitives.electricGreen[500],
                },
            },
            product: {
                ultimate: primitives.product.ultimateOrangeRed,
                standard: primitives.legacy.brand.legacyCyan[500],
                offpeak: primitives.legacy.brand.darkBlue,
                student: primitives.legacy.brand.darkBlue,
            },
        },
        text: {
            label: primitives.darkBlue[500],
            placeholder: primitives.neutral[800],
            error: primitives.ragRed[500],
            savings: primitives.legacy.rag.red,
            action: {
                disabled: primitives.neutral[800],
                main: primitives.energyBlue[500],
                hover: primitives.energyBlue[600],
                pressed: primitives.energyBlue[700],
                inverse: {
                    main: primitives.electricGreen[500],
                    hover: primitives.electricGreen[600],
                    pressed: primitives.electricGreen[700],
                    disabled: primitives.neutral[200],
                },
            },
            body: {
                main: primitives.darkBlue[500],
                inverse: primitives.neutral[0],
            },
            heading: {
                main: primitives.darkBlue[500],
                brand: primitives.energyBlue[500],
            },
            on: {
                attention: primitives.electricGreen[800],
                success: primitives.ragGreen[700],
                error: primitives.ragRed[700],
                information: primitives.cyan[700],
                disabled: primitives.neutral[800],
                action: {
                    main: primitives.neutral[0],
                    inverse: primitives.electricGreen[800],
                    promo: primitives.neutral[0],
                    secondary: primitives.energyBlue[500],
                    secondaryInverse: primitives.electricGreen[500],
                    secondaryTonal: primitives.energyBlue[600],
                },
                selection: {
                    activated: primitives.neutral[0],
                    deactivated: primitives.darkBlue[500],
                },
                promoSuccess: {
                    main: primitives.electricGreen[800],
                    inverse: primitives.electricGreen[500],
                },
            },
            product: {
                ultimate: primitives.product.ultimateOrangeRed,
                standard: primitives.legacy.brand.legacyCyan[500],
                offpeak: primitives.legacy.brand.darkBlue[500],
                student: primitives.legacy.brand.darkBlue[500],
            },
        },
        surface: {
            main: primitives.neutral[0],
            inverse: primitives.darkBlue[500],
            brand: primitives.energyBlue[500],
            brand1: primitives.energyBlue[500],
            brand2: primitives.electricGreen[500],
            brand3: primitives.darkBlue[500],
            brand4: primitives.cyan[500],
            information: primitives.neutral[100],
            error: primitives.ragRed[100],
            warning: primitives.ragAmber[500],
            success: primitives.ragGreen[100],
            scrim: primitives.blackTransparent[40],
            field: {
                main: primitives.neutral[0],
                disabled: primitives.neutral[100],
            },
            container: {
                main: primitives.neutral[50],
                stack: primitives.neutral[100],
            },
            action: {
                main: primitives.energyBlue[500],
                hover: primitives.energyBlue[600],
                pressed: primitives.energyBlue[700],
                disabled: primitives.neutral[200],
                inverse: {
                    main: primitives.electricGreen[500],
                    hover: primitives.electricGreen[600],
                    pressed: primitives.electricGreen[700],
                },
                secondary: {
                    main: primitives.neutral[0],
                    hover: primitives.energyBlue[100],
                    pressed: primitives.energyBlue[200],
                },
                secondaryInverse: {
                    main: primitives.blackTransparent[0],
                    hover: primitives.electricGreen[800],
                    pressed: primitives.electricGreen[700],
                },
                secondaryTonal: {
                    main: primitives.energyBlue[50],
                    hover: primitives.energyBlue[100],
                    pressed: primitives.energyBlue[300],
                    success: primitives.electricGreen[500],
                },
                tertiary: {
                    main: primitives.blackTransparent[0],
                    hover: primitives.energyBlue[100],
                    pressed: primitives.energyBlue[200],
                },
                promo: {
                    main: primitives.energyBlue[600],
                    hover: primitives.energyBlue[500],
                    pressed: primitives.energyBlue[400],
                    success: primitives.electricGreen[800],
                },
                destructive: {
                    main: primitives.ragRed[500],
                    hover: primitives.ragRed[600],
                    pressed: primitives.ragRed[700],
                },
                backToTop: {
                    main: primitives.darkBlue[500],
                    hover: primitives.darkBlue[300],
                    pressed: primitives.darkBlue[200],
                },
                selection: {
                    activated: primitives.energyBlue[700],
                    deactivated: primitives.neutral[0],
                    deactivatedSwitch: primitives.neutral[700],
                    hover: primitives.neutral[100],
                    pressed: primitives.neutral[400],
                    disabled: primitives.darkBlue[100],
                },
            },
            attention: {
                strong: primitives.electricGreen[500],
                subtle: primitives.electricGreen[200],
            },
            product: {
                ultimate: primitives.product.ultimateOrangeRed,
                standard: primitives.legacy.brand.legacyCyan[500],
                offpeak: primitives.product.offPeakSilverGrey,
                student: primitives.legacy.brand.darkBlue[500],
            },
        },
    };
};

export const tggLightPalette = createTggPalette(lightPrimitives);
